import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/AudiusLogoHorizontalColor.svg'

export const IconAudiusLogoHorizontalColor = IconSVG as IconComponent
